module.exports = __webpack_public_path__ + "img/qyrz.edb82fdc.png";